import React, { Component } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import { Typography } from "@mui/material";
import Estekhdam from "../../static/icons/estekhdam.png";
import MasrafKonande from "../../static/icons/masrafkonande.png";
import TaminKonande from "../../static/icons/taminkonande.png";

class HamkariBaMa extends Component {
  state = {};
  render() {
    const { handleComToShow } = this.props;
    return (
      <Grid item xs={12} mt={5}>
        <Grid container justifyContent="center" spacing={2.5}>
          {[
            {
              menuText: "استخدام",
              icon: Estekhdam,
              compName: "estekhdam",
            },
            {
              menuText: "مصرف کننده",
              icon: MasrafKonande,
              compName: "masrafkonandeh",
            },
            {
              menuText: "تامین کننده",
              icon: TaminKonande,
              compName: "masrafkonandeh",
            },
          ].map((menuItem, index) => (
            <Grid key={index} item xs={4}>
              <div onClick={() => handleComToShow(menuItem.compName)}>
                <Stack
                  justifyContent="center"
                  alignItems="center"
                  spacing={0.5}
                >
                  <Avatar src={menuItem.icon} sx={{ width: 96, height: 96 }} />
                  <Typography variant="caption">{menuItem.menuText}</Typography>
                </Stack>
              </div>
            </Grid>
          ))}
        </Grid>
      </Grid>
    );
  }
}

export default HamkariBaMa;
